import MainClass, { MAIN_CLASS_PARAMS } from "@scriptFe/utils/mainClass.ts";
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
// import Splitting from "splitting";
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {IconImpactFrame} from "../../../gutenberg/components/SVGs/iconImpactFrame";
gsap.registerPlugin(ScrollTrigger);




class ImpactFrameWork extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}

	handleBeforeInitAnimate(Elms:HTMLElement[]){
		Elms.forEach((item,index)=>{
			index !== 0 ? (
				item.classList.add('md:absolute'),
					item.classList.add('w-full'),
				gsap.set(item.querySelector('figure'),{
					opacity: 0
				}),
				gsap.set(item,{top:0,left:0})
			) : item.querySelector('figure').innerHTML = IconImpactFrame()

			gsap.set(item.querySelector('.raise-heading'),{opacity: 0, y:50})
				gsap.set(item.querySelector('.raise-paragraph'),{opacity: 0, y:50})
				gsap.set(item.querySelector('.wp-block-raise-raise-button'),{opacity: 0, y:50})

		})
	}

	handleInitStateSvg(SvgI:HTMLElement){
		if(window.matchMedia('(max-width: 599px)').matches){
			let createDiv = document.createElement('div')
			let getParentNode = SvgI.parentNode
			createDiv.appendChild(SvgI)
			createDiv.classList.add('sticky')
			createDiv.classList.add('top-0')
			createDiv.classList.add('raise-ip-svg-sticky')
			getParentNode.classList.add('hidden')
			this.selector.insertBefore(createDiv, this.selector.firstChild);
		}
		gsap.set(SvgI.querySelector('#stage-1-path-1'),{
			rotation:-45,
			opacity:0,
			scale:0.1,
			transformOrigin:"center center",
		})
		gsap.set(SvgI.querySelector('#stage-2-path-1'),{
			scale:.57,
			opacity:0,
			x:0,
			y:-20,
			transformOrigin:"center center",
		})
		gsap.set(SvgI.querySelectorAll('#stage-2-path-4,#stage-2-path-5,#stage-2-path-2,#stage-2-path-3'),{
			opacity:0,
			transformOrigin:"center center",
		})
		gsap.set(SvgI.querySelectorAll('#stage-2-path-2'),{
			x:-20
		})
		gsap.set(SvgI.querySelectorAll('#stage-2-path-3'),{
			x:20
		})
		gsap.set(SvgI.querySelectorAll('#stage-2-path-4'),{
			x:-40
		})
		gsap.set(SvgI.querySelectorAll('#stage-2-path-5'),{
			x:40
		})
		gsap.set(SvgI.querySelectorAll('#stage-3-path-1,#stage-3-path-2,#stage-3-path-3'),{
			scale:0,
			opacity:0,
			transformOrigin:"center center",
		})
		gsap.set(SvgI.querySelectorAll('#stage-3-path-3'),{
			rotation:270
		})
	}

	fetchReplaceSVG(Image,index) {
		return new Promise((resolve, reject) => {
			const url = Image?.getAttribute('data-src');
			if (!url) return resolve();
			let getImageFromBaseSource =''
			if(index == 0){
				getImageFromBaseSource = `${window.apiObjectBE.themeImageUrl}/impact-framework-1.svg`
			}else if(index == 1){
				getImageFromBaseSource = `${window.apiObjectBE.themeImageUrl}/impact-framework-2.svg`
			}else{
				getImageFromBaseSource = `${window.apiObjectBE.themeImageUrl}/impact-framework-3.svg`
			}
			fetch(getImageFromBaseSource)
				.then(response => response.text())
				.then(svgText => {
					const container = Image.closest('.raise-image-media');
					if (!container) return resolve(); // resolve early if not found

					container.innerHTML = svgText;

					const svgElement = container.querySelector('svg');
					if (svgElement) {
						svgElement.classList.add('w-full')
						svgElement.classList.add('md:h-auto')
						svgElement.classList.add('h-full')
						container.classList.add('md:h-auto')
						container.classList.add('md:h-[256px]')
						gsap.set(svgElement,{opacity:0})
						// Optional: you can pass it back
						resolve(svgElement);
					} else {
						resolve();
					}
				})
				.catch(error => {
					console.error('SVG fetch failed:', error);
					resolve(); // Don't reject to avoid breaking Promise.all
				});
		});
	}

	handleInitImageState(getAllChildImpact:HTMLElement[]){
		if(getAllChildImpact.length === 0) return
		if(window.matchMedia('(max-width:767px)').matches){
			gsap.set(getAllChildImpact[1],{
				zIndex:-1,
			})
			gsap.set(getAllChildImpact[2],{
				zIndex:-1,
			})
		}

		//Phase 1
		gsap.set(getAllChildImpact[0].querySelector('.raise-image-media svg>g>rect:nth-child(4)'),{
			rotation:0,
			opacity:0,
			scale:0.5,
			transformOrigin:"center center",
		})
		gsap.set(getAllChildImpact[0].querySelector('.raise-image-media svg>g>g:nth-child(5)'),{
			opacity:0,
			scale:0,
			transformOrigin:"center center",
		})
		gsap.set(getAllChildImpact[0].querySelectorAll('.raise-image-media svg>g>path:nth-last-child(1), .raise-image-media svg>g>path:nth-last-child(2)'),{
			opacity:0,
			y:120,
			transformOrigin:"center center",
		})

		//Phase 2
		if(getAllChildImpact[1].querySelector('.raise-image-media svg')){
			gsap.set(getAllChildImpact[1].querySelector('.raise-image-media svg>g:nth-last-child(2)'),{
				x:'50%',
				y:'50%',
				opacity:'0',
				scale:1.5,
				transformOrigin:"center center",
			})
			gsap.set(getAllChildImpact[1].querySelector('.raise-image-media svg>g:nth-child(2)'),{
				x:'-50%',
				y:'-50%',
				opacity:'0',
				scale:1.5,
				transformOrigin:"center center",
			})
			gsap.set(getAllChildImpact[1].querySelector('.raise-image-media svg>g:nth-child(3)'),{
				x:'50%',
				y:'-50%',
				opacity:'0',
				scale:1.5,
				transformOrigin:"center center",
			})
			gsap.set(getAllChildImpact[1].querySelector('.raise-image-media svg>g:nth-child(4)'),{
				x:'-50%',
				y:'50%',
				opacity:'0',
				scale:1.5,
				transformOrigin:"center center",
			})
		}

		if(getAllChildImpact[2].querySelector('.raise-image-media svg')){
			gsap.set(getAllChildImpact[2].querySelectorAll('.raise-image-media svg>g>g'),{
				y:120,
				opacity:'0',
				transformOrigin:"center center",
			})
		}
	}

	handleAnimationDesktop(tl,getAllChildImpact,SvgI){
		// Phase 1
		tl
			.addLabel('phase-1')
			.to(getAllChildImpact[0].querySelectorAll('.raise-heading,.raise-paragraph,.wp-block-raise-raise-button'),{
				opacity:1,
				stagger:0.1,
				y:0,
			})
			.from(SvgI.querySelectorAll('#stage-1-outline'),{
				opacity:0,
				scale:0.1,
				transformOrigin:"center center",
			})
			.to(SvgI.querySelectorAll("#stage-1-outline"),{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
			})
			.addLabel('phase-1-image-animate')
			.fromTo(SvgI.querySelectorAll('#stage-1-path-1'),{
				opacity:0,
				scale:0.1,
				transformOrigin:"center center",
			},{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
			},'phase-1-image-animate')
			.fromTo(SvgI.querySelectorAll('#stage-1-path-1'),{
				rotation:-45,
				transformOrigin:"center center",
			},{
				rotation:0,
				transformOrigin:"center center",
			},'phase-1-image-animate+=0.2')
			.fromTo(SvgI.querySelectorAll('#circle-path'),{
				opacity:0,
				scale:0.1,
				transformOrigin:"center center",
			},{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
			},'phase-1-image-animate+=0.2')
			.fromTo(getAllChildImpact[0].querySelector('.raise-image-media svg'),{
				opacity:0,
				scale:0,
				transformOrigin:"center center"
			},{opacity:1, scale:1},'phase-1-image-animate+=0.3')

			.to(getAllChildImpact[0].querySelector('.raise-image-media svg>g>rect:nth-child(4)'),{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
				rotation:45
			},'phase-1-image-animate+=0.6')
			.to(getAllChildImpact[0].querySelector('.raise-image-media svg>g>g:nth-child(5)'),{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
			},'phase-1-image-animate+=0.7')
			.to(getAllChildImpact[0].querySelectorAll('.raise-image-media svg>g>path:nth-last-child(1), .raise-image-media svg>g>path:nth-last-child(2)'),{
				opacity:1,
				y:0,
				transformOrigin:"center center",
			},'phase-1-image-animate+=0.9')


		//Animation Phase 2
		tl
			.addLabel('phase-2')
			.to(getAllChildImpact[0].querySelectorAll('.raise-heading,.raise-paragraph,.wp-block-raise-raise-button'),{
				opacity:0,
				y:-120,
			})
			.fromTo(getAllChildImpact[1],{
				zIndex:-1,
			},{zIndex:1})
			.to(getAllChildImpact[1].querySelectorAll('.raise-heading,.raise-paragraph,.wp-block-raise-raise-button'),{
				opacity:1,
				stagger:0.1,
				y:0,
			})
			.addLabel('phase-2-stage-2')
			.to(SvgI.querySelectorAll('#stage-1-outline, #stage-1-path-1'),{
				opacity:0
			},'phase-2-stage-2')
			.to(SvgI.querySelectorAll('#stage-1-path-1'),{
				rotation:45
			},'phase-2-stage-2')
			.to(SvgI.querySelectorAll('#circle-path'),{
				scale:1.773,
				y:-20,
			},'phase-2-stage-2+=0.4') //Run animation when label reached 60%
			.to(SvgI.querySelector('#stage-2-path-1'),{
				scale:1,
				x:0,
				y:0,
				opacity:1
			},'phase-2-stage-2+=0.4')
			.to(getAllChildImpact[0].querySelector('.raise-image-media svg'),{
				opacity:0
			},'phase-2-stage-2+=0.8')
			.to(getAllChildImpact[0].querySelector('.raise-image-media svg>g>rect:nth-child(4)'),{
				opacity:0,
				scale:1.25,
				transformOrigin:"center center",
				rotation:0
			},'phase-2-stage-2+=0.8')
			.to(getAllChildImpact[0].querySelector('.raise-image-media svg>g>g:nth-child(5)'),{
				opacity:0,
				scale:.5,
				transformOrigin:"center center",
			},'phase-2-stage-2+=0.8')
			.to(getAllChildImpact[0].querySelectorAll('.raise-image-media svg>g>path:nth-last-child(1), .raise-image-media svg>g>path:nth-last-child(2)'),{
				opacity:0,
				y:120,
				transformOrigin:"center center",
			},'phase-2-stage-2+=0.8')
			.addLabel('phase-2-stage-3')
			.to(SvgI.querySelectorAll('#stage-2-path-4,#stage-2-path-5'),{
				x:0,
				y:0,
				opacity:1
			},'phase-2-stage-3')
			.to(SvgI.querySelectorAll('#stage-2-path-2,#stage-2-path-3'),{
				x:0,
				y:0,
				opacity:1
			},'phase-2-stage-3+=0.2')
			.to(getAllChildImpact[1].querySelectorAll('.raise-image-media svg,.raise-image-media svg>g'),{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
			},'phase-2-stage-3+=0.4')
			.to(getAllChildImpact[1].querySelectorAll('.raise-image-media svg>g'),{
				y:0,
				transformOrigin:"center center",
			},'phase-2-stage-3+=0.6')
			.to(getAllChildImpact[1].querySelectorAll('.raise-image-media svg>g'),{
				x:0,
				transformOrigin:"center center",
			},'phase-2-stage-3+=1')

		// Phase 3 Animation
		tl.addLabel('phase-3-stage-1')
		tl.to(getAllChildImpact[1].querySelectorAll('.raise-heading,.raise-paragraph,.wp-block-raise-raise-button'),{
			opacity:0,
			y:-120,
		})
			.fromTo(getAllChildImpact[1],{
				zIndex:1,
			},{zIndex:-1})
			.to(getAllChildImpact[2].querySelectorAll('.raise-heading,.raise-paragraph,.wp-block-raise-raise-button'),{
				opacity:1,
				stagger:0.1,
				y:0,
			})
			.fromTo(getAllChildImpact[2],{
				zIndex:-1,
			},{zIndex:1})
			.addLabel('phase-3-stage-2')
			.to(SvgI.querySelectorAll('#stage-2-path-4,#stage-2-path-5'),{
				opacity:0
			},'phase-3-stage-2')
			.to(SvgI.querySelectorAll('#stage-2-path-2'),{
				x:-40,
				opacity:1
			},'phase-3-stage-2')
			.to(SvgI.querySelectorAll('#stage-2-path-3'),{
				x:40,
				opacity:1
			},'phase-3-stage-2')

			.addLabel('phase-3-stage-3')
			.to(SvgI.querySelectorAll('#stage-2-path-2,#stage-2-path-3,#stage-2-path-1'),{
				y:-40,
			},'phase-3-stage-3')
			.to(SvgI.querySelectorAll('#stage-2-path-2,#stage-2-path-3,#stage-2-path-1'),{
				opacity:0,
			},'phase-3-stage-3')

			.addLabel('phase-3-stage-4')
			.to(SvgI.querySelectorAll('#circle-path'),{
				y:-44,
				x:44,
				scale:3.9,
				transformOrigin:"center center",
			},'phase-3-stage-4+=0.3')
			.to(getAllChildImpact[1].querySelectorAll('.raise-image-media svg>g:nth-child(2), .raise-image-media svg>g:nth-child(3)'),{
				y:"-100%",
				transformOrigin:"center center",
			},'phase-3-stage-4+=0.3')
			.addLabel('phase-3-stage-4-2')
			.to(getAllChildImpact[1].querySelectorAll('.raise-image-media svg>g:nth-child(4), .raise-image-media svg>g:nth-child(2)'),{
				x:"-100%",
				transformOrigin:"center center",
			},'phase-3-stage-4-2')
			.addLabel('phase-3-stage-4-3')
			.to(SvgI.querySelectorAll('#stage-3-path-1,#stage-3-path-2,#stage-3-path-3'),{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
				stagger:0.1,
			},'phase-3-stage-4-3')
			.to(getAllChildImpact[1].querySelectorAll('.raise-image-media svg>g'),{
				opacity:0,
				transformOrigin:"center center",
			},'phase-3-stage-4-3')
			.addLabel('phase-3-stage-5')
			.to(getAllChildImpact[2].querySelectorAll('.raise-image-media svg'),{
				opacity:1,
			},'phase-3-stage-5')
			.addLabel('phase-3-stage-6')
			.to(getAllChildImpact[2].querySelectorAll('.raise-image-media svg>g>g:nth-child(2),.raise-image-media svg>g>g:nth-child(4),.raise-image-media svg>g>g:nth-child(3)'),{
				opacity:1,
				stagger:0.2,
				y:0
			},'phase-3-stage-6')
	}

	handleAnimationMobile(getAllChildImpact,SvgI){

			const timeLinePhase1 = gsap.timeline({
				scrollTrigger: {
					trigger: getAllChildImpact[0],
					start: `top +=75%`,
					end: `bottom +=100%`,
					scrub: .5
				}
			});

			timeLinePhase1
				.from(SvgI.querySelectorAll('#stage-1-outline'),{
					opacity:0,
					scale:0.1,
					transformOrigin:"center center",
				})
				.to(SvgI.querySelectorAll("#stage-1-outline"),{
					opacity:1,
					scale:1,
					transformOrigin:"center center",
				})
				.to(getAllChildImpact[0].querySelectorAll('.raise-heading,.raise-paragraph,.wp-block-raise-raise-button'),{
				scrollTrigger:{
					trigger: getAllChildImpact[0],
				},
				opacity:1,
				stagger:0.1,
				y:0,
			})

			.addLabel('phase-1-image-animate')
			.fromTo(SvgI.querySelectorAll('#stage-1-path-1'),{
				opacity:0,
				scale:0.1,
				transformOrigin:"center center",
			},{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
			},'phase-1-image-animate')
			.fromTo(SvgI.querySelectorAll('#stage-1-path-1'),{
				rotation:-45,
				transformOrigin:"center center",
			},{
				rotation:0,
				transformOrigin:"center center",
			},'phase-1-image-animate+=0.2')
			.fromTo(SvgI.querySelectorAll('#circle-path'),{
				opacity:0,
				scale:0.1,
				transformOrigin:"center center",
			},{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
			},'phase-1-image-animate+=0.2')
			.fromTo(getAllChildImpact[0].querySelector('.raise-image-media svg'),{
				opacity:0,
				scale:0,
				transformOrigin:"center center"
			},{opacity:1, scale:1},'phase-1-image-animate+=0.3')

			.to(getAllChildImpact[0].querySelector('.raise-image-media svg>g>rect:nth-child(4)'),{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
				rotation:45
			},'phase-1-image-animate+=0.6')
			.to(getAllChildImpact[0].querySelector('.raise-image-media svg>g>g:nth-child(5)'),{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
			},'phase-1-image-animate+=0.7')
			.to(getAllChildImpact[0].querySelectorAll('.raise-image-media svg>g>path:nth-last-child(1), .raise-image-media svg>g>path:nth-last-child(2)'),{
				opacity:1,
				y:0,
				transformOrigin:"center center",
			},'phase-1-image-animate+=0.9')


		//Animation Phase 2
		const timeLinePhase2 = gsap.timeline({
			scrollTrigger: {
				trigger: getAllChildImpact[1],
				start: `top +=75%`,
				end: `bottom +=100%`,
				scrub: .5
			}
		});
		timeLinePhase2
			.addLabel('phase-2')
			.to(getAllChildImpact[1].querySelectorAll('.raise-heading,.raise-paragraph,.wp-block-raise-raise-button'),{
				opacity:1,
				stagger:0.1,
				y:0,
			})
			.addLabel('phase-2-stage-2')
			.to(SvgI.querySelectorAll('#stage-1-outline, #stage-1-path-1'),{
				opacity:0
			},'phase-2-stage-2')
			.to(SvgI.querySelectorAll('#stage-1-path-1'),{
				rotation:45
			},'phase-2-stage-2')
			.to(SvgI.querySelectorAll('#circle-path'),{
				scale:1.773,
				y:-20,
			},'phase-2-stage-2+=0.4') //Run animation when label reached 60%
			.to(SvgI.querySelector('#stage-2-path-1'),{
				scale:1,
				x:0,
				y:0,
				opacity:1
			},'phase-2-stage-2+=0.4')
			.addLabel('phase-2-stage-3')
			.to(SvgI.querySelectorAll('#stage-2-path-4,#stage-2-path-5'),{
				x:0,
				y:0,
				opacity:1
			},'phase-2-stage-3')
			.to(SvgI.querySelectorAll('#stage-2-path-2,#stage-2-path-3'),{
				x:0,
				y:0,
				opacity:1
			},'phase-2-stage-3+=0.2')
			.to(getAllChildImpact[1].querySelectorAll('.raise-image-media svg,.raise-image-media svg>g'),{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
			},'phase-2-stage-3+=0.4')
			.to(getAllChildImpact[1].querySelectorAll('.raise-image-media svg>g'),{
				y:0,
				transformOrigin:"center center",
			},'phase-2-stage-3+=0.6')
			.to(getAllChildImpact[1].querySelectorAll('.raise-image-media svg>g'),{
				x:0,
				transformOrigin:"center center",
			},'phase-2-stage-3+=1')

		// Phase 3 Animation
		const timeLinePhase3 = gsap.timeline({
			scrollTrigger: {
				trigger: getAllChildImpact[2],
				start: `top +=75%`,
				end: `bottom +=100%`,
				scrub: .5
			}
		});
		timeLinePhase3.addLabel('phase-3-stage-1')
		timeLinePhase3
			.to(getAllChildImpact[2].querySelectorAll('.raise-heading,.raise-paragraph,.wp-block-raise-raise-button'),{
				opacity:1,
				stagger:0.1,
				y:0,
			})

			.addLabel('phase-3-stage-2')
			.to(SvgI.querySelectorAll('#stage-2-path-4,#stage-2-path-5'),{
				opacity:0
			},'phase-3-stage-2')
			.to(SvgI.querySelectorAll('#stage-2-path-2'),{
				x:-40,
				opacity:1
			},'phase-3-stage-2')
			.to(SvgI.querySelectorAll('#stage-2-path-3'),{
				x:40,
				opacity:1
			},'phase-3-stage-2')

			.addLabel('phase-3-stage-3')
			.to(SvgI.querySelectorAll('#stage-2-path-2,#stage-2-path-3,#stage-2-path-1'),{
				y:-40,
			},'phase-3-stage-3')
			.to(SvgI.querySelectorAll('#stage-2-path-2,#stage-2-path-3,#stage-2-path-1'),{
				opacity:0,
			},'phase-3-stage-3')

			.addLabel('phase-3-stage-4')
			.to(SvgI.querySelectorAll('#circle-path'),{
				y:-44,
				x:44,
				scale:3.9,
				transformOrigin:"center center",
			},'phase-3-stage-4+=0.3')

			.addLabel('phase-3-stage-4-3')
			.to(SvgI.querySelectorAll('#stage-3-path-1,#stage-3-path-2,#stage-3-path-3'),{
				opacity:1,
				scale:1,
				transformOrigin:"center center",
				stagger:0.1,
			},'phase-3-stage-4-3')
			.addLabel('phase-3-stage-5')
			.to(getAllChildImpact[2].querySelectorAll('.raise-image-media svg'),{
				opacity:1,
			},'phase-3-stage-5')
			.addLabel('phase-3-stage-6')
			.to(getAllChildImpact[2].querySelectorAll('.raise-image-media svg>g>g:nth-child(2),.raise-image-media svg>g>g:nth-child(4),.raise-image-media svg>g>g:nth-child(3)'),{
				opacity:1,
				stagger:0.2,
				y:0
			},'phase-3-stage-6')
	}

	async init () {
		this.selector.classList.add('relative');
		let getAllChildImpact = Array.prototype.slice.call(this.selector.querySelectorAll('.raise-impact-framework.wp-block-raise-raise-impact-framework'));
		let getSpacer = Array.prototype.slice.call(this.selector.querySelectorAll('.raise-impact-report-animate-container>.wp-block-raise-raise-spacer'))
		if (getAllChildImpact.length === 0) return;

		const svgLoadPromises = [];
		if(getSpacer){
			getSpacer.forEach((item)=>{
				item.classList.add('md:hidden')
			})
		}
		getAllChildImpact.forEach((block,index) => {
			const mediaContainer = block.querySelector('.raise-image-media');
			if (!mediaContainer) return;

			const img = mediaContainer.querySelector('img');
			if (!img || !img.getAttribute('data-src')?.includes('.svg')) return;

			// Push to array so we can wait later
			svgLoadPromises.push(this.fetchReplaceSVG(img,index));

			// Observer for re-replace if DOM changes
			const observer = new MutationObserver(() => {
				const newImg = block.querySelector('.raise-image-media img');
				if (newImg && newImg.getAttribute('data-src')?.includes('.svg')) {
					this.fetchReplaceSVG(newImg,index);
				}
			});
			observer.observe(block, {
				childList: true,
				subtree: true
			});
		});

		// ⏳ Wait for all SVGs to load
		await Promise.all(svgLoadPromises);

		// ✅ Now we re-select the blocks — they now contain <svg>
		getAllChildImpact = Array.prototype.slice.call(this.selector.querySelectorAll('.raise-impact-framework.wp-block-raise-raise-impact-framework'));
		this.handleInitImageState(getAllChildImpact)
		this.handleBeforeInitAnimate(getAllChildImpact);

		const SvgI = getAllChildImpact[0].querySelector('.raise-impact-frame-animation-icon');
		SvgI.classList.add('w-full')
		SvgI.classList.add('h-auto')
		let startPosition = window.matchMedia('(max-width:599px)').matches ? 40 : 180
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: this.selector,
				pin: window.matchMedia('(min-width:600px)').matches,
				start: `top +=${startPosition}`,
				end: `+=${this.selector.offsetHeight * 6}`,
				preventOverlaps:true,
				fastScrollEnd:4000,
				scrub: .5,
				pinType:"fixed"
			}
		});

		this.handleInitStateSvg(SvgI);
		// Init State Image Phase 1
		!window.matchMedia('(max-width:599px)').matches ?
		this.handleAnimationDesktop(tl,getAllChildImpact,SvgI) :
		this.handleAnimationMobile(getAllChildImpact,SvgI)

		ScrollTrigger.refresh()
	}
}

export default ImpactFrameWork;
